import classNames from 'classnames';
import React, { FC, memo } from 'react';
import SizeCodeDefaultImage from 'shared/assets/images/SizeCodeDefaultImage.png';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { getLocalizedString } from 'shared/utils/helpers/JSONLocalization';
import { SizeCodeForBooking, SizeCodeType } from 'entities/SizeCode';
import { formatDecimal } from 'shared/utils/helpers/formatDecimal';

interface SizeCodeCardMobileProps {
  sizeCode: SizeCodeForBooking;
  isSelected: boolean;
  onClick: () => void;
}

export const SizeCodeCardMobile: FC<SizeCodeCardMobileProps> = memo((props) => {
  const { sizeCode, isSelected, onClick } = props;
  const { square, availableBoxesCount, imageUrl, description, sizeCodeType } = sizeCode;

  const { t } = useAppTranslation('booking');

  const noAvailableBoxes = availableBoxesCount === 0;

  return (
    <div
      className={classNames('flex min-h-[80px] items-center p-2 rounded-lg cursor-pointer relative', {
        'cursor-default': noAvailableBoxes,
        'border-2 border-accent bg-green-50': isSelected,
        'hover:outline hover:outline-accent': !isSelected && !noAvailableBoxes,
        'border-1.5 border-grey': !isSelected && noAvailableBoxes,
        'opacity-50': noAvailableBoxes,
      })}
      onClick={!noAvailableBoxes ? onClick : undefined}
    >
      <div className="shrink-0 mr-4">
        <img className="w-16 h-16 object-contain" src={imageUrl || SizeCodeDefaultImage} alt="Size image" />
      </div>

      <div className="flex-1 min-w-0">
        <div className="text-xl font-bold text-primary mb-1 font-tektur">
          {formatDecimal(square)} м<sup className="text-sm font-tektur font-bold">{sizeCodeType === SizeCodeType.CUBIC_BOX ? 3 : 2}</sup>
        </div>
        {description && <div className="text-sm text-grey" dangerouslySetInnerHTML={{ __html: getLocalizedString(description) }} />}
        {noAvailableBoxes && <div className="text-sm text-grey mt-1">{t('No available boxes in this category')}</div>}
      </div>
    </div>
  );
});
